// Module
var code = "<a class=\"text-sm sps-btn sps-btn-outline btn-color-follow-up follow-up-button\"> <i class=\"fa fa-arrow-up\"></i><span><!-- ko text: _labels.FOLLOW_UP --><!-- /ko --></span> </a> ";
// Exports
export default code;